<lib-dropdown-panel [buttonTemplateRef]="notificationsPanel" [source]="panel"></lib-dropdown-panel>

<ng-template #notificationsPanel>
    <div class="icon" [innerHTML]="notificationPanelIcon"></div>
</ng-template>
